<template>
    <div class="container">
        <container></container>
    </div>
</template>

<script>
import container from "../../components/container"
export default {
    components: {
        container,
    },
    data() {
        return {
            vertical: '',
            horizontal: '',
        }
    },
}
</script>

<style lang="scss" scoped>

</style>